/* Match catalog fields explicitly. Shopify still owns ranking, filters and pagination. */
(function (root) {
  'use strict';
  const fields = ['title', 'tag', 'product_type', 'vendor', 'variants.title', 'variants.sku', 'variants.barcode'];
  const stopwords = new Set(['a', 'an', 'and', 'or', 'the', 'for', 'of', 'to', '&']);
  const categoryWords = { watch:'watches', watches:'watch', clock:'clocks', clocks:'clock', accessory:'accessories', accessories:'accessory' };
  function tokens(value) {
    return String(value || '').trim().split(/\s+/).map(function (word) {
      return word.replace(/^["'()]+|["'(),.]+$/g, '');
    }).filter(function (word) { return /[\p{L}\p{N}]/u.test(word) && !stopwords.has(word.toLowerCase()); });
  }
  // Theme settings → Search behavior → "Exclude vendor from search" (data-search-exclude-vendor on the
  // search forms): added after the fielded query, so the visitor never sees or types it.
  function exclusion() {
    if (typeof document === 'undefined') return '';
    const el = document.querySelector('[data-search-exclude-vendor]');
    const vendor = el ? el.getAttribute('data-search-exclude-vendor').trim() : '';
    return vendor ? ' AND NOT vendor:' + JSON.stringify(vendor) : '';
  }
  function buildQuery(value, legacy = false, exclude = true) {
    const words = tokens(value);
    if (!words.length && String(value || '').trim()) words.push(String(value).trim());
    if (!words.length) return '';
    return fieldedQuery(words, legacy) + (exclude ? exclusion() : '');
  }
  function fieldedQuery(words, legacy) {
    return words.map(function (word) {
      const alternate = !legacy && categoryWords[word.toLowerCase()];
      const variants = alternate ? [word, alternate] : [word];
      return '(' + fields.flatMap(function (field) {
        return variants.map(function (variant) { return field + ':' + JSON.stringify(variant); });
      }).join(' OR ') + ')';
    }).join(' AND ');
  }
  function decodeQuery(query) {
    const matches = [...String(query || '').matchAll(/\(title:("(?:[^"\\]|\\.)*") OR /g)];
    if (!matches.length) return null;
    try {
      const value = matches.map(function (match) { return JSON.parse(match[1]); }).join(' ');
      // Also URLs from before the vendor exclusion (normalizedURL then adds it).
      return [buildQuery(value), buildQuery(value, true), buildQuery(value, false, false), buildQuery(value, true, false)].indexOf(query) > -1 ? value : null;
    } catch (_) { return null; }
  }
  function normalizedURL(value) {
    const url = new URL(value);
    const query = url.searchParams.get('q');
    if (!query || !query.trim()) return null;
    const decoded = decodeQuery(query);
    const display = url.searchParams.get('search_query');
    const plain = decoded !== null ? (display && buildQuery(display) === query ? display : decoded) : query;
    const scoped = buildQuery(plain);
    if (query === scoped && url.searchParams.get('type') === 'product' && url.searchParams.get('options[prefix]') === 'none') return null;
    if (query !== scoped || url.searchParams.get('type') !== 'product') url.searchParams.delete('page');
    url.searchParams.set('q', scoped);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'none');
    url.searchParams.set('search_query', plain);
    return url.href;
  }
  const api = { tokens, buildQuery, decodeQuery, normalizedURL };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  if (root.MeridianProductSearch) return;
  root.MeridianProductSearch = api;
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form.matches('.header-search__form, .psr__search-form')) return;
    const input = form.querySelector('input[name="q"]');
    if (!input || !input.value.trim()) return;
    event.preventDefault();
    const url = new URL(form.action, root.location.origin);
    url.search = new URLSearchParams(new FormData(form)).toString();
    url.searchParams.set('q', buildQuery(input.value));
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'none');
    url.searchParams.set('search_query', input.value.trim());
    root.location.assign(url.href);
  }, true);
  function ready() {
    const page = document.querySelector('[data-product-search-page]');
    if (!page) return;
    const next = normalizedURL(root.location.href);
    if (next) { root.location.replace(next); return; }
    const url = new URL(root.location.href);
    const query = url.searchParams.get('q') || '';
    const decoded = decodeQuery(query);
    const supplied = url.searchParams.get('search_query');
    const display = supplied && (!query || buildQuery(supplied) === query) ? supplied : (decoded !== null ? decoded : query);
    document.querySelectorAll('.psr__search-input, .header-search__input').forEach(function (input) { input.value = display; });
    const heading = page.querySelector('[data-product-search-heading]');
    if (heading && page.dataset.searchPerformed === 'true') {
      heading.textContent = (page.dataset.searchHasResults === 'true' ? 'Results for “' : 'No results for “') + display + '”';
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})(typeof window !== 'undefined' ? window : globalThis);
